export const sleep = time => new Promise(resolve => setTimeout(() => resolve(), time));

export const range = (start, length) => Array.from(new Array(length), (_, i) => start + i);

export const isExist = value => value !== null && value !== '' && typeof value !== 'undefined';

export const isEmpty = value => !isExist(value);

export const normalizePrice = num => {
	if (num.length <= 3) {
		return num;
	}

	return `${normalizePrice(num.slice(0, -3))},${num.slice(-3)}`;
};

export const mapValueFromServer = value => (isEmpty(value) ? '' : value);

// https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
export const isInternetExplorer = () =>
	window.navigator.userAgent.indexOf('MSIE ') > 0 ||
	window.navigator.userAgent.indexOf('Trident/') > 0;
